import { QueryHookOptions, useQuery } from '@apollo/client';
import getPlatformAccountsQuery from './managedPlatformAccountsQuery.graphql';

export const useManagedPlatformAccountsQuery = (
  options: QueryHookOptions<
    ManagedPlatformAccountsQuery,
    ManagedPlatformAccountsQueryVariables
  >,
) => {
  return useQuery<
    ManagedPlatformAccountsQuery,
    ManagedPlatformAccountsQueryVariables
  >(getPlatformAccountsQuery, options);
};
